'use client';

// Centralized, consent-aware GTM event sender
// Sends only when analytics consent is granted (window.__analyticsGranted)
export function sendEvent(payload: Record<string, unknown>): void {
  try {
    const w = window as any;
    if (!w.__analyticsGranted) {
      queueEvent(payload);
      return;
    }
    w.dataLayer = w.dataLayer || [];
    w.gtag =
      w.gtag ||
      function () {
        // biome-ignore lint/complexity/noArguments: official gtag snippet pushes the arguments object as-is
        w.dataLayer.push(arguments);
      };
    // Push as GTM event object (compatible with existing GTM setup)
    w.dataLayer.push(payload);
  } catch {
    // no-op
  }
}

// Simple queue to flush once analytics consent is granted
const pending: Record<string, unknown>[] = [];

function queueEvent(evt: Record<string, unknown>) {
  pending.push(evt);
}

export function flushQueuedIfGranted() {
  try {
    const w = window as any;
    if (!w.__analyticsGranted) return;
    // Wait a tick so GTM is fully attached, then drain
    setTimeout(() => {
      try {
        if (!w.dataLayer) w.dataLayer = [];
        if (!w.gtag)
          w.gtag = function () {
            // biome-ignore lint/complexity/noArguments: official gtag snippet pushes the arguments object as-is
            w.dataLayer.push(arguments);
          };
        while (pending.length) {
          const evt = pending.shift()!;
          w.dataLayer.push(evt);
        }
      } catch {}
    }, 0);
  } catch {
    // ignore
  }
}
